import { Grid, withStyles } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import FormDefinition from '../../FormDefinition';
import { OrderReviewContext } from '../../OrderReviewContext';

const DefaultFlatFormHeader = ({
  formDefinitions,
  saveAnswersAsync,
  removeAnswersAsync,
  editPropertyCharacteristics,
}) => {
  // #region STATE
  // #endregion STATE

  // #region HOOKS
  const { state } = useContext(OrderReviewContext);
  // #endregion HOOKS

  // #region COMPUTED
  const formDefinitionsToRender = formDefinitions.filter(
    fd => fd.questionCategoryName !== 'Order Info' && (state.showAllAnswers || !!fd.answers?.length),
    // (
    //   fd.answers.some(a => a.images.length === 0) ||
    //   // (!fd.answers && state.showAllAnswers) ||
    //   // (fd.answers.length === 0 && state.showAllAnswers)

    //   (
    //     state.showAllAnswers && (
    //       !fd.answers || fd.answers.length === 0
    //     )
    //   )

    // ||
    // (!!fd.answers.length && state.showAllAnswers)
    // ),
  );
  // #endregion COMPUTED

  // #region FUNCTIONS
  const determineIsReadOnlyAnswer = formDefinition => {
    if (formDefinition?.fieldContext === 'Read Only') {
      return true;
    }
    return false;
  };
  // #endregion FUNCTIONS

  // #region EFFECTS
  useEffect(() => {
    // console.log('defaultFormHeader');
  }, []);
  // #endregion EFFECTS

  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            padding: '24px 24px 0 24px',
          }}
        >
          {formDefinitionsToRender.map((fd, i) => (
            <FormDefinition
              key={fd.formDefinitionId}
              saveAnswers={saveAnswersAsync}
              removeAnswers={removeAnswersAsync}
              formDefinition={fd}
              isReadOnly={editPropertyCharacteristics || determineIsReadOnlyAnswer(fd)}
            />
          ))}
        </div>
      </Grid>
    </Grid>
  );
};

export default DefaultFlatFormHeader;
